import { AccessDeniedError } from "helpers/error";
import { UserCookie } from "models";
import { CustomErrorBoundary } from "models/error/errorModel";
import IPermissionValidator from "./IPermissionValidator";

class UserRoleValidator implements IPermissionValidator {

    constructor(private readonly role: string) {

    }
    validate(user: UserCookie | null): boolean {
        return this.role === user?.role;
    }
    trhow(): CustomErrorBoundary {
        throw new AccessDeniedError()
    }

}

export default UserRoleValidator;